import { NameValuePair } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { TextProps } from '@features/powerpoint';
import { contentSlideTitleText } from '../../../../slides/content-slide-title-text';
import { topAudienceToTextProps } from './top-audience-to-text-props';
import { extraAudienceToTextProps } from './extra-audience-to-text-props';

export const TOP_AUDIENCES_COUNT = 4;
export const EXTRA_AUDIENCES_COUNT = 6;

export type TextsOptions = {
  nameValuePairsByGroup: {
    top: NameValuePair[];
    extra: NameValuePair[];
  };
};

export const texts = (options: TextsOptions): TextProps[] => {
  return [
    contentSlideTitleText(
      '<lci>Audience</lci> <b>Profile (Saw the Ad & Visited)</b>'
    ),
    ...options.nameValuePairsByGroup.top.flatMap((nameValuePair, index) =>
      topAudienceToTextProps(nameValuePair, index)
    ),
    ...options.nameValuePairsByGroup.extra.flatMap((nameValuePair, index) =>
      extraAudienceToTextProps(nameValuePair, index)
    ),
  ];
};
